(function () {
  var STAGGER = 800;

  function initTimeline(root) {
    if (!root || root.dataset.customTimelineReady) return;
    root.dataset.customTimelineReady = 'true';
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-timeline-step]'));
    if (!steps.length) return;

    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (step) {
        step.classList.add('is-active');
      });
      return;
    }

    var queue = [];
    var busy = false;
    var lastScroll = window.scrollY;

    function runQueue() {
      if (!queue.length) {
        busy = false;
        return;
      }
      busy = true;
      var step = queue.shift();
      step.classList.add('is-active');
      window.setTimeout(runQueue, STAGGER);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var scrollingDown = window.scrollY > lastScroll;
        lastScroll = window.scrollY;
        entries.forEach(function (entry) {
          var step = entry.target;
          if (entry.isIntersecting) {
            if (!step.classList.contains('is-active') && queue.indexOf(step) === -1) {
              queue.push(step);
              if (!busy) runQueue();
            }
          } else if (!scrollingDown) {
            step.classList.remove('is-active');
            var index = queue.indexOf(step);
            if (index !== -1) queue.splice(index, 1);
          }
        });
      },
      { threshold: 1 }
    );

    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-custom-timeline]').forEach(initTimeline);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTimeline(event.target.querySelector('[data-custom-timeline]'));
  });
})();